import React from "react";
import ChartWrapper from "../graph/ChartWrapper";
import {
  CardData,
  CategoryDef,
} from "api/interfaces/dashboardInterface.interface";
import useStatsData from "hook/useStatsData";
import { getDashboardCamera } from "api/widgetAPI";

export default function Cameras(props: CardData) {
  const { statsData, data, legend, interval, setInterval } = useStatsData({
    queryFn: getDashboardCamera,
    queryName: "camerasStatsGraph",
    items: props.items as CategoryDef[],
  });
  return (
    <ChartWrapper
      rows={data}
      items={props.items as CategoryDef[]}
      onChangeInterval={setInterval}
      interval={interval}
      legend={legend}
      isLoading={statsData.isLoading}
    />
  );
}
